export default "#container{width:100%;height:700px;margin-top:5px;margin-bottom:5px;overflow:hidden;border:2px solid silver;border-radius:3px}";